import Toaster from "@/components/toaster";
import Protected from "@/pages/protected";
import { DataService } from "@/services/data";
import { Outlet, RouteObject, defer, redirect } from "react-router-dom";

const SalesRoute: RouteObject = {
    path: "ventes",
    element: (
        <Protected groups={["app_tools_admin"]}>
            <Outlet />
        </Protected>
    ),
    children: [
        {
            index: true,
            async lazy() {
                let { SalesSearchPage } = await import("@/pages/tools/sales/search");
                return { Component: SalesSearchPage };
            }
        },
        {
            id: "sales-main",
            path: ":task_id",
            element: <Outlet />,
            loader: async ({ params }) => {
                const task_id = decodeURIComponent(params.task_id || "");
                const sales = await DataService.client.url(`/tools/sales/${task_id}/`).get().json();
                const picklists = await DataService.client.url(`/tools/sales/picklists/`).get().json();
                const sf_task = DataService.client.url(`/tools/sales/task/${task_id}/`).get().json();
                return defer({ sales, picklists, sf_task });
            },
            children: [
                {
                    index: true,
                    async lazy() {
                        let { SalesStep1Page } = await import("@/pages/tools/sales/step-1");
                        return { Component: SalesStep1Page };
                    },
                    action: async ({ request }) => {
                        const data = await request.json();
                        try {
                            await DataService.client.url(`/tools/sales/${data.task_id}/`).patch(data).json();
                            return redirect(`/outils/ventes/${encodeURIComponent(data.task_id)}/session`);
                        } catch (e) {
                            console.error(e);
                            Toaster.error(`Une erreur est survenue`);
                            return {};
                        }
                    }
                },
                {
                    path: "session",
                    async lazy() {
                        let { SalesStep2Page } = await import("@/pages/tools/sales/step-2");
                        return { Component: SalesStep2Page };
                    },
                    action: async ({ request }) => {
                        const data = await request.json();
                        try {
                            await DataService.client.url(`/tools/sales/${data.task_id}/`).patch(data).json();
                            return redirect(`/outils/ventes/${encodeURIComponent(data.task_id)}/facturation`);
                        } catch (e) {
                            console.error(e);
                            Toaster.error(`Une erreur est survenue`);
                            return {};
                        }
                    }
                },
                {
                    path: "facturation",
                    async lazy() {
                        let { SalesStep3Page } = await import("@/pages/tools/sales/step-3");
                        return { Component: SalesStep3Page };
                    },
                    action: async ({ request }) => {
                        const data = await request.json();
                        try {
                            await DataService.client.url(`/tools/sales/${data.task_id}/`).patch(data).json();
                            return redirect(`/outils/ventes/${encodeURIComponent(data.task_id)}/recap`);
                        } catch (e) {
                            console.error(e);
                            Toaster.error(`Une erreur est survenue`);
                            return {};
                        }
                    }
                },
                {
                    path: "recap",
                    async lazy() {
                        let { SalesStep4Page } = await import("@/pages/tools/sales/step-4");
                        return { Component: SalesStep4Page };
                    },
                    action: async ({ request }) => {
                        const data = await request.json();
                        try {
                            await DataService.client.url(`/tools/sales/${data.task_id}/submit/`).post({}).json();
                            return redirect(`/outils/ventes/${encodeURIComponent(data.task_id)}/success`);
                        } catch (e) {
                            console.error(e);
                            Toaster.error(`Une erreur est survenue`);
                            return {};
                        }
                    }
                }
            ]
        },
        {
            path: ":task_id/success",
            async lazy() {
                let { SalesSuccessPage } = await import("@/pages/tools/sales/success");
                return { Component: SalesSuccessPage };
            }
        }
    ]
};
export default SalesRoute;
